import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chemAdjustmentConfigByNodeId: {},
  // Stores full API response per nodeId for cache-hit checks
  chemicalAdjustmentByNodeId: {},
};

export const ChemicalAdjustmentSlice = createSlice({
  name: "chemicalAdjustment",
  initialState,
  reducers: {
    setCaseChemicalAdjustmentList: (state, action) => {
      state.chemAdjustmentConfigByNodeId = {
        ...state.chemAdjustmentConfigByNodeId,
        ...(action.payload || {}),
      };
    },
    setAdjustmentResponseForNode: (state, action) => {
      const { nodeId, response } = action.payload;
      state.chemicalAdjustmentByNodeId[nodeId] = response;
    },
    resetChemicalAdjustmentData: state => {
      state.chemAdjustmentConfigByNodeId = {};
      state.chemicalAdjustmentByNodeId = {};
    },
  },
});

export const { setCaseChemicalAdjustmentList, setAdjustmentResponseForNode, resetChemicalAdjustmentData } =
  ChemicalAdjustmentSlice.actions;

export default ChemicalAdjustmentSlice.reducer;
